import React, { Fragment } from 'react';

import styles from './onboardingSidebarStyles.scss';

import ProfileImage from 'buyside/components/presentation/ProfileImage/profileImage';

export const SidebarMassImport = ({
  fileName,
  numberOfTickers,
  showRemove,
  removeMassImport,
  disabled
}) => (
  <div>
    <strong>{fileName}</strong> ({numberOfTickers})&nbsp;
    {showRemove && (
      <span className={disabled ? styles.disable : styles.remove} onClick={removeMassImport}>
        remove
      </span>
    )}
  </div>
);

export const SidebarTicker = ({ showRemove, disabled, primarySymbol, name, unfollow }) => (
  <div>
    <strong>{primarySymbol}</strong>
    &nbsp;- {name}&nbsp;
    {showRemove && (
      <span
        className={disabled ? styles.disable : styles.remove}
        onClick={disabled ? () => {} : unfollow}
      >
        remove
      </span>
    )}
  </div>
);

export const SidebarUser = ({
  displayName,
  currentEmployerName,
  profileImageUrl,
  unfollow,
  disabled,
  showRemove
}) => (
  <div className={styles.sidebarUser}>
    <div className={styles.profileImage}>
      <ProfileImage source={profileImageUrl} size="small" />
    </div>
    <div className={styles.nameArea}>
      <div>
        <strong>{displayName}</strong>
      </div>
      <div className={styles.employerName}>{currentEmployerName}</div>
    </div>
    {showRemove && (
      <div className={`${styles.remove} ${disabled ? styles.disable : ''}`}>
        <span onClick={disabled ? () => {} : unfollow}>Remove</span>
      </div>
    )}
  </div>
);

export const SidebarWatchlistList = ({ listItems, title }) => (
  <Fragment>
    <h3 className={styles.watchlistHeader}>{title}</h3>
    <div className={styles.watchlistContent}>
      {listItems.map((listItem, idx) => (
        <div key={idx}>{listItem.name}</div>
      ))}
    </div>
  </Fragment>
);
